import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { graphql, Link, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import { INSTA_LINK } from "../../utils/constants";

const queryForImages = graphql`
  query {
    allImageSharp(
      filter: {
        fluid: {
          originalName: {
            in: [
              "follow_image1.png"
              "follow_image2.png"
              "follow_image3.png"
              "follow_image4.png"
              "follow_image5.png"
              "follow_image6.png"
            ]
          }
        }
      }
    ) {
      nodes {
        fluid(maxHeight: 254, maxWidth: 254) {
          originalName
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;

const Separator = forwardRef((props, ref) => {
  const clientWidth =
    typeof window !== "undefined"
      ? Math.min(window?.document?.body?.clientWidth, 1440)
      : 0;
  const parallaxLeftText = [
    {
      start: "self",
      duration: 3000,
      properties: [
        {
          startValue: -200,
          endValue: clientWidth,
          property: "translateX",
        },
      ],
    },
  ];
  const parallaxLeftImages = [
    {
      start: "self",
      duration: 3000,
      properties: [
        {
          startValue: 0,
          endValue: clientWidth,
          property: "translateX",
        },
      ],
    },
  ];
  const result = useStaticQuery(queryForImages);
  const { allImageSharp = {} } = result || {},
    { nodes = [] } = allImageSharp;
  let allImages = nodes.map((img) => {
    return img.fluid;
  });
  allImages = allImages.sort((img1, img2) => {
    if (img1.originalName > img2.originalName) return 1;
    else if (img1.originalName < img2.originalName) return -1;
    else return 0;
  });
  allImages = [...allImages, ...allImages, ...allImages];
  const { t } = useTranslation();
  return (
    <>
      <div className="separator">
        <div className="text-container">
          <p className="desktop:desktop-h1 mobile:mobile-h1 tablet:mobile-h1 marquee">
            <span>
              &nbsp;#NOAHSGREENKITCHEN&nbsp;@NOAHSGREENKITCHEN &nbsp;
              {t("separatorInfo")}&nbsp;
            </span>
            <span>
              &nbsp;#NOAHSGREENKITCHEN&nbsp;@NOAHSGREENKITCHEN &nbsp;
              {t("separatorInfo")}&nbsp;
            </span>
            <span>
              &nbsp;#NOAHSGREENKITCHEN&nbsp;@NOAHSGREENKITCHEN &nbsp;
              {t("separatorInfo")}&nbsp;
            </span>
          </p>
        </div>
        <Link to={INSTA_LINK} target={"_blank"}>
          <div className="with-images" id={"follow"} ref={ref}>
            <div className="images-container">
              {allImages.map((img) => {
                return <Img fluid={img} />;
              })}
            </div>
          </div>
        </Link>
      </div>
      <div className="separator-divider layout desktop:container-desktop mobile:container-mobile tablet:container-mobile"></div>
    </>
  );
});

export default Separator;
